<template>
  <div class="top-nav">
    <el-row :gutter="10" justify="space-between">
      <el-col :xs="{span:20, push:1}" :sm="{span:20, push:1}" :md="{span:20, push:1}" :lg="{span:12, push:1}" :xl="{span:12, push:1}">
        <div class="top-logo">
          <el-image class="top-logo-image" :fit="'fill'" :src="logoUrl" alt="logo" />
          <span class="top-logo-title">&nbsp;{{menu[0]}}</span>
        </div>
      </el-col>
      <el-col :xs="{span:4, pull:1}" :sm="{span:4, pull:1}" :md="{span:4, pull:1}" :lg="{span:12, pull:1}" :xl="{span:12, pull:1}">
        <div class="top-menu">
          <div class="desktop-layout">
              <el-menu mode="horizontal" :default-active="activeIndex" @select="handleSelect">
              <el-menu-item index="1"><span class="top-menu-item">{{menu[1]}}</span></el-menu-item>
              <el-menu-item index="2"><span class="top-menu-item">{{menu[2]}}</span></el-menu-item>
              <el-menu-item index="3"><span class="top-menu-item">{{menu[3]}}</span></el-menu-item>
              <el-menu-item index="4"><span class="top-menu-item">{{menu[4]}}</span></el-menu-item>
              <el-menu-item index="5"><span class="top-menu-item">{{menu[5]}}</span></el-menu-item>
              <!-- <el-menu-item index="6"><span class="top-menu-item">{{menu[6]}}</span></el-menu-item> -->
              <el-menu-item index="6">
                <el-switch 
                  v-model="switchValue" 
                  inline-prompt
                  active-text="中"
                  inactive-text="EN" 
                  size="large" 
                  :style="switchStyle"
                />
              </el-menu-item>
            </el-menu>
          </div>
          <div class="mobile-layout">
            <el-button @click="handleOpen"><el-icon><Fold /></el-icon></el-button>
            <el-drawer v-model="isOpenDrawer" :show-close="false" :append-to-body="true" size="60%" :before-close="handleClose">
              <el-menu mode="vertical" :default-active="activeIndex" @select="handleSelect">
              <el-menu-item index="1"><span class="top-menu-item">{{menu[1]}}</span></el-menu-item>
              <el-menu-item index="2"><span class="top-menu-item">{{menu[2]}}</span></el-menu-item>
              <el-menu-item index="3"><span class="top-menu-item">{{menu[3]}}</span></el-menu-item>
              <el-menu-item index="4"><span class="top-menu-item">{{menu[4]}}</span></el-menu-item>
              <el-menu-item index="5"><span class="top-menu-item">{{menu[5]}}</span></el-menu-item>
              <!-- <el-menu-item index="6"><span class="top-menu-item">{{menu[6]}}</span></el-menu-item> -->
              <el-menu-item index="6">
                <el-switch 
                  v-model="switchValue" 
                  inline-prompt
                  active-text="中"
                  inactive-text="EN" 
                  size="large" 
                  :style="switchStyle"
                />
              </el-menu-item>
            </el-menu>
            </el-drawer>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>


<script>
import { Fold } from '@element-plus/icons-vue'
import { Store } from '@/utils/store'
import { Lang } from '@/utils/language'
// import { themeColor } from '@/assets/variables.scss';
export default {
  name: 'TopNav',
  components: { Fold },
  props: {
    logo: {
      required: true,
      type: String
    }
  },
  data() {
    return {
      isOpenDrawer: false,
      activeIndex: '1',
      switchValue: true,
      switchStyle: `--el-switch-on-color: #58B6FE; --el-switch-off-color: #58B6FE; padding-top: 8px;`,
      // switchStyle: `--el-switch-on-color: ${themeColor}; --el-switch-off-color: ${themeColor}; padding-top: 8px;`,
      logoUrl: this.logo,
    }
  },
  created() {
    // console.log(this.switchStyle)
  },
  computed: {
    menu() {
      if (this.switchValue) {
        Store.changeLang('cn');
        return Lang.Menu.cn;
      } else {
        Store.changeLang('en');
        return Lang.Menu.en;
      }
    },
  },
  methods: {
    handleOpen(){
        this.isOpenDrawer = true;
    },
    handleClose(){
        this.isOpenDrawer = false;
    },    
    handleSelect(idx) {
      switch(idx) {
        case '1':
          this.$router.push({ name: 'Home' });
          break;
        case '2':
          this.$router.push({ name: 'Cee' });
          break;
        case '3':
          this.$router.push({ name: 'Position' });
          break;
        case '4':
          this.$router.push({ name: 'Planning' });
          break;
        case '5':
          this.$router.push({ name: 'Consultant' });
          break;
        case '6':
        //   this.$router.push({ name: 'About' });
        //   break;
        // case '7':
        default:
          this.activeIndex = Store.preIndex;
      }
      this.handleClose();
    }
  }
}
</script>


<style lang="scss">
@import '@/assets/variables.scss';
.top-nav {
  z-index: 1;
  width: 100%;
  height: $top-height;
  border-bottom: 1px solid rgba(144, 147, 153, 0.2);
  background-color: white;
}
.top-logo {
  padding-top: 15px;
  text-align: left;
  cursor: pointer;
}
.top-logo-image {
  width: 40px; 
  height: 40px;
  vertical-align: middle;
}
.top-logo-title {
  font-size: 2em;
  font-weight: 700;
  color: $theme-color;
  vertical-align: middle;
}
.top-menu {
  padding-top: 15px;
  // text-align: right;
}
.top-menu-item {
  font-family: Poppins;  
  font-size: 1.3em;
  font-weight: 400;
}

/* 设置了浏览器宽度不小于1080px时 显示的宽度 */
@media screen and (min-width: 1080px) {
  .desktop-layout {
    display: block;
  }
  .mobile-layout {
    display: none;
  }
}
@media screen and (max-width: 1080px) and (orientation: portrait) {
  .desktop-layout {
    display: none;
  }
  .mobile-layout {
    display: block;
  }  
}
</style>
